import { call, put, select } from 'redux-saga/effects';
import { setSpeakerVolume, setNotificationVolume } from '../../../state/audioDevice/audioDeviceSlice';
import { changeSpeakerVolume, changeNotificationVolume } from '../../../utils/audioUtils';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';

export function* changeSpeakerVolumeSaga(action) {
    try {
        const volume = action.payload;
        const success = yield call(changeSpeakerVolume, volume);
        
        if (success) {
            yield put(setSpeakerVolume(volume));
        } else {
            throw new Error('Failed to set volume');
        }
    } catch (error) {
        console.error('Error changing speaker volume:', error);
        yield put(showSnackbar({
            message: 'Failed to change speaker volume',
            severity: 'error'
        }));
    }
}

export function* changeNotificationVolumeSaga(action) {
    try {
        const volume = action.payload;
        const success = yield call(changeNotificationVolume, volume);
        
        if (success) {
            yield put(setNotificationVolume(volume));
        } else {
            throw new Error('Failed to set volume');
        }
    } catch (error) {
        console.error('Error changing notification volume:', error);
        yield put(showSnackbar({
            message: 'Failed to change notification volume',
            severity: 'error'
        }));
    }
}